import { useEffect, useState } from 'react';
import { fetchApiAuth } from './api';

/**
 * Fetches an authenticated image URL and returns a blob URL for use in <img> src.
 */
const useAuthImage = (url: string | null | undefined): { blobUrl: string | undefined; loading: boolean } => {
    const [blobUrl, setBlobUrl] = useState<string | undefined>(undefined);
    const [loading, setLoading] = useState<boolean>(!!url);

    useEffect(() => {
        if (!url) {
            setBlobUrl(undefined);
            setLoading(false);
            return undefined;
        }

        // Data URIs are already self-contained — no fetch needed
        if (url.startsWith('data:')) {
            setBlobUrl(url);
            setLoading(false);
            return undefined;
        }

        let cancelled = false;
        let objectUrl: string | undefined;
        setLoading(true);

        fetchApiAuth({
            method: 'GET',
            responseType: 'blob',
            url,
        }).then((response) => {
            if (!cancelled) {
                objectUrl = window.URL.createObjectURL(new Blob([response.data]));
                setBlobUrl(objectUrl);
                setLoading(false);
            }
        }).catch(() => {
            if (!cancelled) {
                setBlobUrl(undefined);
                setLoading(false);
            }
        });

        return () => {
            cancelled = true;
            if (objectUrl) {
                window.URL.revokeObjectURL(objectUrl);
            }
        };
    }, [url]);

    return { blobUrl, loading };
};

export default useAuthImage;
